import React, { useEffect, useState } from 'react';
import './style.scss'

interface AutocompleteProps {
    options: Object[];
}

const Autocomplete: React.FC<AutocompleteProps> = ({ options }) => {
    const [inputValue, setInputValue] = useState<string>('');
    const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
    const [updatedOptions, setUpdatedOptions] = useState<string[]>([])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);
        if (value.length) {
            // Filter options based on the input value
            if (value.length < 3) {
                setFilteredOptions(updatedOptions.filter(option => option.toLowerCase().startsWith(value.toLowerCase())));
            } else {
                setFilteredOptions(updatedOptions.filter(option => option.toLowerCase().includes(value.toLowerCase())));
            }
        } else {
            setFilteredOptions([])
        }
    };

    const handleOptionClick = (option: string) => {
        setInputValue(option);
        setFilteredOptions([]);
    };

    useEffect(() => {
        if (options?.length) {
            setUpdatedOptions(options.map((option: any) => option?.value))
        }
    }, [options])

    return (
        <div className='auto-complete-container'>
            <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Type to search..."
            />
            {filteredOptions?.length > 0 && <div className='menu-items-container'>
                <ul>
                    {filteredOptions.map((option, index) => (
                        <li key={index} onClick={() => handleOptionClick(option)}>
                            {option}
                        </li>
                    ))}
                </ul>
            </div>}
        </div>
    );
};

export default Autocomplete
